export default __webpack_public_path__ + "static/media/Dashboard.7783b3c3.svg";